import React from 'react';
import MainTemplate from 'pages/templates/MainTemplate';
import MainContentTemplate from 'pages/templates/MainContentTemplate';

import Statistics from './Statistics';

const BrowserStatistics = () => {
  return (
    <MainTemplate>
      <MainContentTemplate>
        <Statistics />
      </MainContentTemplate>
    </MainTemplate>
  );
};

export default BrowserStatistics;
